import React from 'react';

const IconMail = props =>
  <svg viewBox="0 0 22 22" {...props}>
    <path d="M21 16.333c0 0.468-0.13 0.901-0.338 1.282l-6.63-7.536l6.559-5.829C20.846 4.661 21 5.145 21 5.667V16.333z M10.5 11.448l9.126-8.112C19.252 3.127 18.83 3 18.375 3H2.625c-0.456 0-0.877 0.127-1.25 0.336L10.5 11.448z M13.044 10.957 l-2.112 1.879C10.808 12.945 10.654 13 10.5 13c-0.155 0-0.309-0.055-0.432-0.164l-2.113-1.879L1.241 18.59 C1.643 18.846 2.115 19 2.625 19h15.75c0.51 0 0.981-0.154 1.385-0.41L13.044 10.957z M0.409 4.25C0.154 4.661 0 5.145 0 5.667 v10.667c0 0.468 0.129 0.901 0.337 1.282l6.63-7.537L0.409 4.25z" />
  </svg>;

export default IconMail;
